// Extend centralised data-testid tokens for stable QA hooks
export const NAV = {
  root: "site-nav",
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkProperties: "nav-link-properties",
  linkAbout: "nav-link-about",
  linkFaq: "nav-link-faq",
  linkContact: "nav-link-contact",
  linkHost: "nav-link-host",
  themeToggle: "theme-toggle",
  loginBtn: "nav-login-btn",
};

export const HOME = {
  hero: "home-hero",
  heroHeadline: "home-hero-headline",
  searchDestination: "home-search-destination",
  searchDates: "home-search-dates",
  searchGuests: "home-search-guests",
  searchSubmit: "home-search-submit",
  featuredGrid: "home-featured-grid",
  collectionsScroller: "home-collections-scroller",
  testimonial: "home-testimonial",
  hostBanner: "home-host-banner",
  hostBannerCta: "home-host-banner-cta",
};

export const PROPS = {
  filterBar: "props-filter-bar",
  filterLocation: "props-filter-location",
  filterPrice: "props-filter-price",
  filterGuests: "props-filter-guests",
  filterAmenity: "props-filter-amenity",
  toggleMap: "props-toggle-map",
  toggleGrid: "props-toggle-grid",
  grid: "props-grid",
  map: "props-map",
  card: (id) => `property-card-${id}`,
  cardSave: (id) => `property-card-save-${id}`,
  resultsCount: "props-results-count",
};

export const DETAIL = {
  root: "detail-root",
  title: "detail-title",
  gallery: "detail-gallery",
  bookingWidget: "detail-booking-widget",
  bookingDates: "detail-booking-dates",
  bookingGuests: "detail-booking-guests",
  bookingReserve: "detail-booking-reserve",
  amenities: "detail-amenities",
  reviews: "detail-reviews",
};

export const FOOTER = {
  root: "site-footer",
  wordmark: "footer-wordmark",
  newsletterInput: "footer-newsletter-input",
  newsletterSubmit: "footer-newsletter-submit",
};

export const ABOUT = {
  root: "about-root",
  hero: "about-hero",
  cta: "about-cta",
};

export const CONTACT = {
  root: "contact-root",
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  subject: "contact-subject",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
};

export const FAQ = {
  root: "faq-root",
  search: "faq-search",
  category: (id) => `faq-category-${id}`,
  item: (i) => `faq-item-${i}`,
  empty: "faq-empty",
};

export const TERMS = {
  root: "terms-root",
  toc: "terms-toc",
  section: (id) => `terms-section-${id}`,
};

export const POLICIES = {
  root: "policies-root",
};

export const HOSTPLAN = {
  root: "hostplan-root",
  plan: (id) => `hostplan-card-${id}`,
  cta: (id) => `hostplan-cta-${id}`,
};
